// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2wrwu","checkbox-checkmark":"Checkbox_checkbox-checkmark__1wTOx","is-checked":"Checkbox_is-checked__1rnEg"};